import { useState, useEffect } from 'react';
import Login from './Login';
import Dashboard from './Dashboard';
import VesselForm from './VesselForm';
import VSADGenerator from './VSADGenerator';
import VesselAuditManagement from './VesselAuditManagement';
import LibraryManager from './LibraryManager';
import IMSManager from './IMSManager';
import QDMSAnalyzer from './QDMSAnalyzer';
import UserManagement from './UserManagement';
import EmailAssistant from './EmailAssistant';
import BlameCatcher from './BlameCatcher';
import PSCGuard from './PSCGuard';
import BrainStorm from './BrainStorm';
import ReportTracker from './ReportTracker';
import FleetManagement from './FleetManagement';
import { getMyModules, logoutAPI } from './api';

export default function App() {
  const [auth, setAuth] = useState(!!localStorage.getItem('token'));
  const [page, setPage] = useState('dashboard');
  const [selectedVessel, setSelectedVessel] = useState(null);
  const [allowedModules, setAllowedModules] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);

  const fetchModules = async () => {
    try {
      const res = await getMyModules();
      setAllowedModules(res.data.modules || []);
      setIsAdmin(res.data.is_admin || false);
    } catch { /* token may be expired, leave as-is */ }
  };

  useEffect(() => { if (auth) fetchModules(); }, [auth]);

  const handleLogin = () => { setAuth(true); };
  const handleLogout = async () => {
    try { await logoutAPI(); } catch { /* ignore — token may already be expired */ }
    localStorage.removeItem('token');
    setAuth(false);
    setAllowedModules([]);
    setIsAdmin(false);
    setPage('dashboard');
  };

  const canAccess = (key) => isAdmin || allowedModules.includes(key);
  const guardedPage = (key, component) => canAccess(key) ? component : <Dashboard onLogout={handleLogout} setPage={setPage} allowedModules={allowedModules} isAdmin={isAdmin} />;

  if (!auth) return <Login onLogin={handleLogin} />;
  if (page === 'vessel-form') return <VesselForm vessel={selectedVessel} setPage={setPage} onLogout={handleLogout} />;
  if (page === 'users') return <UserManagement setPage={setPage} onLogout={handleLogout} />;
  if (page === 'vsad')           return guardedPage('vsad',           <VSADGenerator setPage={setPage} onLogout={handleLogout} setEditVessel={setSelectedVessel} />);
  if (page === 'audit')          return guardedPage('audit',          <VesselAuditManagement setPage={setPage} onLogout={handleLogout} />);
  if (page === 'library')        return guardedPage('library',        <LibraryManager setPage={setPage} onLogout={handleLogout} />);
  if (page === 'ims')            return guardedPage('ims',            <IMSManager setPage={setPage} onLogout={handleLogout} />);
  if (page === 'qdms-analyzer')  return guardedPage('qdms-analyzer',  <QDMSAnalyzer setPage={setPage} onLogout={handleLogout} />);
  if (page === 'email-assistant')return guardedPage('email-assistant',<EmailAssistant setPage={setPage} onLogout={handleLogout} />);
  if (page === 'blamecatcher')   return guardedPage('blamecatcher',   <BlameCatcher setPage={setPage} onLogout={handleLogout} />);
  if (page === 'psc-guard')      return guardedPage('psc-guard',      <PSCGuard setPage={setPage} onLogout={handleLogout} />);
  if (page === 'brainstorm')     return guardedPage('brainstorm',     <BrainStorm setPage={setPage} onLogout={handleLogout} />);
  if (page === 'report-tracker')   return guardedPage('report-tracker',   <ReportTracker setPage={setPage} onLogout={handleLogout} isAdmin={isAdmin} />);
  if (page === 'fleet-management') return guardedPage('fleet-management', <FleetManagement setPage={setPage} onLogout={handleLogout} setEditVessel={setSelectedVessel} />);

  return <Dashboard onLogout={handleLogout} setPage={setPage} allowedModules={allowedModules} isAdmin={isAdmin} />;
}
